var map = {
	"./web_app_aa.json": 70175,
	"./web_app_de.json": 71616,
	"./web_app_en.json": 3227,
	"./web_app_es.json": 65278,
	"./web_app_ja.json": 49594,
	"./web_app_nl.json": 55104,
	"./web_app_pl.json": 16064,
	"./web_app_pt.json": 69802,
	"./web_app_tr.json": 79187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8224;